import { useQuery } from '@tanstack/react-query';
import { queries } from '../../../../../../shared/queries';
import { handleError } from '../../../../../ui/err/handleError';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../../shared/types';

export default function useGetDevices(params: any) {
  return useQuery({
    ...queries.devices.list(params),
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
